document.addEventListener("DOMContentLoaded", function () {
  // alert("hello");
  // Helper function to remove products from the cart
  async function removeProducts(productsToRemove) {
    const removePromises = productsToRemove.map((productId) => {
      return fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `updates[${productId}]=0`,
      });
    });
    await Promise.all(removePromises);
  }

  // Helper function to add free cash product to the cart
  async function addFreeCash(freeProduct) {
    const formData = { items: [{ id: freeProduct, quantity: 1 }] };
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
  }

  // Main function to update the cart based on the total
  async function updateCart(CartTotal) {
    // Define the product IDs that correspond to the cash amounts
    const cashAmounts = {
      40114119082058: 5, // $5 cash
      40114119114826: 10, // $10 cash
      40114119147594: 15, // $15 cash
    };

    // Get the current cart
    const cartData = await fetch("/cart.js", { method: "GET" }).then(
      (response) => response.json()
    );
    const productsInCart = cartData.items.map((item) => item.id.toString());
    const cashProductsInCart = productsInCart.filter((id) =>
      Object.keys(cashAmounts).includes(id)
    );
    let freeProduct;

    // Determine the free product based on the cart total
    console.log("I am cartTotal:", CartTotal);
    if (CartTotal >= 75 && CartTotal < 125) {
      freeProduct = "40114119082058"; // $5 cash
    } else if (CartTotal >= 125 && CartTotal < 175) {
      freeProduct = "40114119114826"; // $10 cash
    } else if (CartTotal >= 175) {
      freeProduct = "40114119147594"; // $15 cash
    }

    // Remove all cash products if cart total is below $75 or if a different cash amount is in the cart
    if (
      CartTotal < 75 ||
      (freeProduct && !cashProductsInCart.includes(freeProduct))
    ) {
      await removeProducts(cashProductsInCart);
    }

    // If the cart qualifies for a cash product and it's not in the cart, add it
    if (freeProduct && !cashProductsInCart.includes(freeProduct)) {
      await addFreeCash(freeProduct);
    }

    // Refresh the cart UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    // Update the cart item list
    const cartItemList = document.querySelector(".Cart__ItemList");
    if (cartItemList) {
      const response = await fetch(location.href);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const newCartItemList = doc.querySelector(".Cart__ItemList").innerHTML;
      cartItemList.innerHTML = newCartItemList;
    }
  }

  // Function to extract the cart total
  function getCartTotal() {
      let CartTotal = document.querySelector(".Cart__Total.Heading span").textContent;
      CartTotal = CartTotal.replace("USD", "").replace("$", "").split(".")[0];
      return parseInt(CartTotal, 10);
  }

  document.addEventListener("cart:change", function (event) {
    let CartTotal = event.detail.cart.total_price / 100;
    updateCart(CartTotal);
  });

  // Initial cart check and update
});
